import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BookFormModule } from '@studiobuki/web-core/lib/book-form';
import { PreviewModule } from '@studiobuki/web-core/lib/preview';
import { SectionMessageDateModule } from '@studiobuki/web-core/lib/section-message-date';
import { SectionReviewsModule } from '@studiobuki/web-core/lib/section-reviews';
import { SectionStepsModule } from '@studiobuki/web-core/lib/section-steps';
import { SectionFaqModule } from '@studiobuki/web-core/lib/section-faq';
import { SectionFooterBannerModule } from 'src/app/shared/section-footer-banner/section-footer-banner.module';
import { SectionFooterBannersModule } from 'src/app/shared/section-footer-banners/section-footer-banners.module';
import { SafePipeModule } from 'safe-pipe';
import { ScrollTopModule } from 'src/app/shared/scroll-top/scroll-top.module';
import { YotpoV3Module } from '@studiobuki/web-core/lib/yotpo-v3';
import { HomePageComponent } from './home-page.component';
import { BannerOneModule } from './components/banner-one/banner-one.module';
import { SectionBooksModule } from '../../shared/section-books/section-books.module';
import { BannerDescriptionComponent } from './components/banner-description/banner-description.component';

@NgModule({
  declarations: [HomePageComponent, BannerDescriptionComponent],
  imports: [
    BannerOneModule,
    BookFormModule,
    CommonModule,
    PreviewModule,
    RouterModule,
    SafePipeModule,
    SectionBooksModule,
    SectionFaqModule,
    SectionFooterBannerModule,
    SectionFooterBannersModule,
    SectionMessageDateModule,
    SectionReviewsModule,
    SectionStepsModule,
    ScrollTopModule,
    YotpoV3Module,
  ],
})
export class HomePageModule {}
